export default __webpack_public_path__ + "static/media/mapMarker.f96aeb96.svg";